/**
 * Klartext für die ZWEI Edge-Verdikte, die Fase A6 neu eingeführt hat
 * (`400 email-domain-blocked`, `429 rate-limited`) — eine Quelle für alle
 * Widgets, die auf `/api/*` posten.
 *
 * THE GAP THIS CLOSES (MINOR-N1 uit de #491-hermeting): A6 legde de nieuwe
 * poorten óók op `/api/lead` en `/api/beratung`, maar de client daarvan
 * (`apps/calculator-ui`) kende de codes niet. Een bezoeker met een
 * wegwerpadres kreeg «prüfen Sie … die Bestätigung (kein Roboter)» en ging de
 * captcha opnieuw oplossen — onactiebaar, want niets zei dat het om het adres
 * ging. Twee widgets, twee kopieën van dezelfde tabel: dezelfde driftklasse
 * als de honeypot-naam vóór `HONEYPOT_FIELD_NAME`.
 *
 * Bewust NIET gedeeld: de generieke 400/403-tekst. Het Bewertungs-widget noemt
 * daar de «Bestätigungscode» (het heeft een OTP-been), de Zinsrechner noemt de
 * captcha — twee verschillende gebruikers, twee juiste teksten. Daarom geeft
 * `edgeFehlerText` **null** terug zodra het verdict niet één van de twee A6-codes
 * is: de beller houdt zijn eigen bewoording.
 *
 * Zod-vrij en zonder imports, zodat een browserbundel dit bestand kan meenemen
 * zonder de schema-barrel binnen te halen.
 */
/** `400 email-domain-blocked` — het adres is een wegwerpadres. */
export const EDGE_TEXT_WEGWERF_MAIL = 'Bitte verwenden Sie eine dauerhafte E-Mail-Adresse (keine Wegwerf-Adresse).';
/** `429` — de burst-rem van de edge (per IP, per mailadres of per OTP-been). */
export const EDGE_TEXT_RATE_LIMIT = 'Zu viele Anfragen — bitte versuchen Sie es in einer Minute erneut.';
/**
 * De gedeelde helft van de foutafbeelding: alleen de twee A6-verdicten die
 * voor de bezoeker écht actiebaar zijn. `null` = geen A6-verdict, de beller
 * gebruikt zijn eigen generieke tekst.
 *
 * Een 400 mag nooit uitleggen WELKE controle faalde aan wie staat te prikken —
 * daarom is `email-domain-blocked` de enige 400 met een eigen tekst.
 */
export function edgeFehlerText(status, code) {
    if (status === 429)
        return EDGE_TEXT_RATE_LIMIT;
    if (status === 400 && code === 'email-domain-blocked')
        return EDGE_TEXT_WEGWERF_MAIL;
    return null;
}
